import React, { Component } from 'react';
import { Row, Col, Grid } from 'react-bootstrap';
import { Link } from 'react-router';
import i18n from 'kodyl-js/i18n/react';

// TODO: Pick dynamically from redux

class CityNav extends Component {
  render() {
    const { hideOthersLink, className } = this.props;
    const colSize = hideOthersLink ? { xs: 12 } : { xs: 12, sm: 9, lg: 10 };
    return (
      <div className={`popular-cities-row ${className || ''}`}>
        <Grid>
          <Row className="element-container">
            <Col {...colSize}>
              <ul className="row element-list">
                <li className="col-xs-6 col-sm-3">
                  <Link to="/koebenhavn">København</Link>
                </li>
                <li className="col-xs-6 col-sm-3">
                  <Link to="/aarhus">Aarhus</Link>
                </li>
                <li className="col-xs-6 col-sm-3">
                  <Link to="/odense">Odense</Link>
                </li>
                <li className="col-xs-6 col-sm-3">
                  <Link to="/aalborg">Aalborg</Link>
                </li>
              </ul>
            </Col>
            {!hideOthersLink && (
              <span
                style={{ textAlign: 'center' }}
                className="col-xs-12 col-sm-3 col-lg-2 element-label"
              >
                <Link to="/byer">{this.i18n('Show all cities')}</Link>
              </span>
            )}
          </Row>
        </Grid>
      </div>
    );
  }
}

export default i18n(CityNav);
